// extracted by mini-css-extract-plugin
module.exports = {"adminWrapper":"adminStyles_adminWrapper__2TZ59","adminTitle":"adminStyles_adminTitle__3lB-O","adminSubtitle":"adminStyles_adminSubtitle__3s2Ig"};